import { useEffect, useState } from "react";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import styles from "./DangerOusPackages.module.scss";
import { DangerousService } from "../../services/dangerousPackages.service";
import { DangerousPackagesDataType } from "../../interface/site.interface";
import Spinner from "../../components/shared/spinner/Spinner";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const DangerousPackages = () => {
  const [goodsData, setGoodsData] = useState<DangerousPackagesDataType | null>(
    null
  );
  const [loading, setLoading] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setLoading(true);
    DangerousService.GetDangerousPackages()
      .then((res) => {
        setGoodsData(res.data);
      })
      .catch(() => console.log("err"))
      .finally(() => setLoading(false));
  }, [language]);

  // function convertToHtml(text: string): string {
  //   return text
  //     .replace(/\r\n|\n|\r/g, "<br/>")
  //     .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
  //     .replace(/&#39;/g, "'");
  // }

  return (
    <div id={styles.forbidden_products}>
      <TitleUpdater
        title={
          data?.colibri && data?.dangerous_goods
            ? `${data?.colibri} | ${data?.dangerous_goods}`
            : "Colibri"
        }
      />
      <div className="container">
        <div className={styles.forbidden_section}>
          <h1 className={styles.section_title}>{data?.dangerous_goods}</h1>
          {loading ? (
            <Spinner size="large" />
          ) : (
            <div className={styles.descriptionContent}>
              <div
                className={styles.descriptionText}
                dangerouslySetInnerHTML={{
                  __html: goodsData ? goodsData.text : "",
                }}
              />
            </div>
          )}
        </div>
        <MobileAppSection />
      </div>
    </div>
  );
};

export default DangerousPackages;
